import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router.tsx";
import { applyCachedSiteConfig } from "./lib/site-config.ts";
import "./styles.css";

/**
 * 🔴 **在 React 挂载之前先把上次的配色/简繁贴上去。**
 *    等接口回来才上色的话，每次打开都会先闪一下默认的赤陶色再跳成后台设的那套 ——
 *    刷新一次闪一次，比"配色不能改"还难受。
 *    这一步只读 localStorage，没有网络等待。真值由根组件拿回来再校正。
 */
applyCachedSiteConfig();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const root = document.getElementById("root");
if (!root) throw new Error("找不到 #root 挂载点");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
